import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Dashboard from './pages/Dashboard';
import Teams from './pages/Teams';
import Matches from './pages/Matches';
import BattingStats from './pages/BattingStats';
import BowlingStats from './pages/BowlingStats';
import Standings from './pages/Standings';
import MatchDetails from './pages/MatchDetails';
import PlayerDetails from './pages/PlayerDetails';
import './App.css';

function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: '/', label: 'Dashboard' },
    { to: '/teams', label: 'Teams' },
    { to: '/matches', label: 'Matches' },
    { to: '/batting-stats', label: 'Batting' },
    { to: '/bowling-stats', label: 'Bowling' },
    { to: '/standings', label: 'Standings' }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav style={{
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(12px)',
      borderBottom: '1px solid #f5f5f4',
      position: 'sticky',
      top: 0,
      zIndex: 100
    }}>
      <div className="nav-container">
        <div className="nav-content">
          <Link to="/" className="nav-logo" style={{ textDecoration: 'none' }}>
            <div className="nav-logo-img">
              <img
                src="/ipl-logo.svg"
                alt="IPL"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: '18px',
                fontWeight: '700',
                color: '#1c1917',
                letterSpacing: '-0.3px'
              }}>
                IPL Stats
              </span>
              <span style={{
                fontSize: '11px',
                color: '#a8a29e',
                fontWeight: '500',
                letterSpacing: '0.5px'
              }}>
                2022 Season
              </span>
            </div>
          </Link>

          <div className="nav-links">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className={`nav-link ${isActive(link.to) ? 'active' : ''}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X style={{ width: '22px', height: '22px' }} />
            ) : (
              <Menu style={{ width: '22px', height: '22px' }} />
            )}
          </button>
        </div>
      </div>

      <div className={`mobile-nav ${mobileMenuOpen ? 'open' : ''}`}>
        {navLinks.map(link => (
          <Link
            key={link.to}
            to={link.to}
            className="mobile-nav-link"
            onClick={() => setMobileMenuOpen(false)}
            style={isActive(link.to) ? {
              backgroundColor: 'rgba(232, 93, 4, 0.08)',
              color: '#e85d04'
            } : {}}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <div style={{ minHeight: '100vh', backgroundColor: '#fafaf9' }}>
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/matches" element={<Matches />} />
            <Route path="/batting-stats" element={<BattingStats />} />
            <Route path="/bowling-stats" element={<BowlingStats />} />
            <Route path="/standings" element={<Standings />} />
            <Route path="/matches/:filename" element={<MatchDetails />} />
            <Route path="/players/:playerId" element={<PlayerDetails />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
